import {
  AUTH_ERRORS,
  AUTH_FLOWS,
  POSSIBLE_AUTH_ERRORS,
  TRACKING
} from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { OAuthProviders } from 'common/utils/assets.utils';
import { omitFromQs, isSurveyFlow } from 'common/utils/utils';
import GdprConsentAgreement from 'components/GdprConsentAgreement';
import { Flex } from 'components/base/layout-components';
import pickBy from 'lodash/pickBy';
import QueryString from 'query-string';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { signIn } from '../../modals/AuthModals/auth.modals.service';
import {
  InvitationExpiredView,
  ProviderBoxesView,
  RequestInvitationView,
  YouLookFamiliar
} from '../../modals/LoginModal/components';
import SSOLogin from '../../modals/LoginModal/components/SSOLogin';
import SurveyLogin from '../../modals/LoginModal/components/SurveyLogin';
import { Header } from './Login.style';
import { Footer } from './Footer';

const GdprConsentAgreementWrapper = styled(Flex)`
  justify-self: flex-end;
`;

const StyledSubHeader = styled('h2')({
  fontSize: 18,
  color: '#000',
  fontWeight: 'normal'
});

const LoginForm = ({
  redirectUrl,
  locationState,
  invitationId,
  invitationExpired,
  authFlow,
  toggleModal
}) => {
  const [isProvidersEnabled, setIsProvidersEnabled] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
        page: TRACKING.PAGES.ONBOARDING,
        page_tab: TRACKING.PAGE_TABS.SIGN_IN,
        isSurveyFlow: isSurveyFlow()
      });
    }, 3000);
  }, []);

  const errorType = (locationState && locationState.type) || null;

  const error = errorType
    ? POSSIBLE_AUTH_ERRORS(locationState)[errorType] ||
      POSSIBLE_AUTH_ERRORS(locationState)['UNKNOWN']
    : null;

  if (errorType === AUTH_ERRORS.REQUEST_INVITATION) {
    return <RequestInvitationView email={locationState.context.email} />;
  }
  if (
    errorType === AUTH_ERRORS.MATCHING_CONTRIBUTOR ||
    errorType === AUTH_ERRORS.SSO_LOGIN_ONLY_MATCHING_CONTRIBUTOR
  ) {
    const requestInvitationToken =
      locationState?.context?.requestInvitationToken;

    const createAccountToken = locationState?.context?.createAccountToken;

    return (
      <YouLookFamiliar
        requestInvitationToken={requestInvitationToken}
        createAccountToken={createAccountToken}
        toggleModal={toggleModal}
        isForceSsoLogin={
          errorType === AUTH_ERRORS.SSO_LOGIN_ONLY_MATCHING_CONTRIBUTOR
        }
      />
    );
  }
  if (invitationExpired) {
    return <InvitationExpiredView />;
  }

  const wrongEmailChecked = errorType === AUTH_ERRORS.WRONG_EMAIL_CHECKED;
  const isLinkFlow = authFlow === AUTH_FLOWS.LINK;
  const withSignUp = !(invitationId || isLinkFlow || wrongEmailChecked);
  const isSurveyFlowUI = isSurveyFlow();

  const subText = isLinkFlow
    ? 'You will be redirected to your organization’s dashboard'
    : invitationId
    ? 'Sign in with the same email you were invited with:'
    : 'Login with:';

  const providers = pickBy(OAuthProviders, provider => provider.isLogin);

  const search = QueryString.parse(window.location.search);
  const headerTitle = isSurveyFlowUI
    ? 'Developer Survey'
    : 'Welcome back to LinearB';

  const { autherr } = search;
  omitFromQs('autherr');

  return (
    <Flex direction='column' height='100%'>
      <Flex direction='column' items='center' grow='1' height='100%'>
        <Flex mt='3.3rem' direction='column' items='center' position='relative'>
          <Header>{headerTitle}</Header>
        </Flex>
        {!isSurveyFlowUI ? (
          <StyledSubHeader>{subText}</StyledSubHeader>
        ) : (
          <SurveyLogin />
        )}

        <ProviderBoxesView
          providers={providers}
          onProviderClick={provider =>
            signIn(`${provider.authIdentity}_identity`, redirectUrl)
          }
          disabled={!isProvidersEnabled}
        />

        <SSOLogin
          isEnabled={isProvidersEnabled}
          ssoError={autherr}
          error={error}
        />

        <GdprConsentAgreementWrapper
          mt='small'
          mb='small'
          height='100%'
          direction='column'
          justify='flex-end'
        >
          <GdprConsentAgreement
            onChange={isChecked => setIsProvidersEnabled(isChecked)}
            onInit={isGdpr => setIsProvidersEnabled(isGdpr)}
          />
        </GdprConsentAgreementWrapper>
      </Flex>
      {withSignUp && !isSurveyFlowUI && <Footer />}
    </Flex>
  );
};

export default LoginForm;
